<!-- Change only the identified area for routes -->

<template>
  <div v-if="useNavbar">
    <nav class="navbar navbar-expand-sm navbar-light bg-light border-bottom">
      <div class="container-fluid">
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbar"
          aria-controls="navbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbar">
          <div class="navbar-nav">
            <!-- Begin Edit Area - Add or update links -->
            <!-- use the named route pattern -->
            <RouterLink :to="{ name: 'Home' }" class="nav-link me-3"
              >Home</RouterLink
            >

            <RouterLink :to="{ name: 'Achievements' }" class="nav-link me-3"
              >Achievements</RouterLink
            >

            <RouterLink :to="{ name: 'Leaderboard' }" class="nav-link me-3"
              >Leaderboard</RouterLink
            >

            <RouterLink :to="{ name: 'FAQ' }" class="nav-link me-3"
              >FAQ</RouterLink
            >

            <!-- <RouterLink :to="{ name: 'Testing' }" class="nav-link me-3"
              >TESTING</RouterLink
            > -->
            <!-- End Edit Area -->
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TheNavbar",
  computed: {
    ...mapGetters(["useNavbar"])
  }
};
</script>
